import { Box, Flex, Text, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import { AnimatedMascot } from 'components/Mascot';
import ConnectPaychexApiModal from 'containers/Integrations/PaychexApi/ConnectPaychexApiModal';
import { useIntegrationStore } from 'store/useIntegrationStore';

import PaychexApiSetting from '../Settings';

const Configuration = () => {
  const { isOpen: isConnectModalOpen, onOpen: onConnectModalOpen, onClose: onConnectModalClose } = useDisclosure();

  const { t } = useTranslation(['integrations']);

  const integrationListData: any = useIntegrationStore(state => state.integrationList);
  const paychexApiIntegrationData = integrationListData.find((tab: any) => tab.key === 'paychex_api');

  return (
    <>
      <ConnectPaychexApiModal isOpen={isConnectModalOpen} onClose={onConnectModalClose} />
      {!paychexApiIntegrationData.is_connected ? (
        <Flex flexDirection="column">
          <Box
            padding="20px 40px"
            border="1px solid"
            borderColor="gray.400"
            background="white"
            textAlign="center"
            mb={6}
          >
            <AnimatedMascot type="barking" />
            <Text>{t('integrations:paychexApi.enableConfiguration')}</Text>
          </Box>
          <Button ml="auto" onClick={onConnectModalOpen}>
            {t('integrations:connect')}
          </Button>
        </Flex>
      ) : (
        <PaychexApiSetting />
      )}
    </>
  );
};
export default Configuration;
